import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { Cta } from '@/components/sections/cta'
import { PageHero } from '@/components/sections/page-hero'
import { ServiceBlock } from '@/components/sections/service-block'
import { servicePages } from '@/constants/content'

const Services: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Services'
                description='Paid advertising that delivers results. Expertly crafted Meta, Google and TikTok ad campaigns built to grow your business.'
            />

            <PageHero
                segments={[
                    { text: 'Paid advertising that delivers' },
                    { text: 'results.', serif: true }
                ]}
                subtitle='Boost your brand’s visibility and drive targeted results with expertly crafted Meta, Google, and TikTok ad campaigns designed to grow your business.'
            />

            {servicePages.map((service, index) => (
                <ServiceBlock
                    key={service.id}
                    id={service.id}
                    title={service.title}
                    body={service.body}
                    included={service.included}
                    investment={service.investment}
                    image={service.image}
                    alt={service.alt}
                    cardLeft={index === 1}
                />
            ))}

            <Cta />
        </Layout>
    )
}

export default Services
